//@ts-nocheck
import React, { useState, useEffect, useCallback } from "react";
import { withStyles, Grid, Typography, createStyles, Button } from "@material-ui/core";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import GetAppIcon from "@material-ui/icons/GetApp";
import RefreshIcon from "@material-ui/icons/Refresh";
import StorageProvider from "../../../../framework/src/StorageProvider";
import DotSpinner from "../../../../components/src/DotSpinner.web";
import { api } from "../../axios";

const getFormattedPDFName = () => {
  const now = new Date();

  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const year = now.getFullYear();

  const hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const formattedHours = String(hours % 12 || 12).padStart(2, "0");

  return `Roadmap: ${month}-${day}-${year} | ${formattedHours}:${minutes}`;
};

export const RoadmapExportDialog = (props: any) => {
  const { classes, dataToPass, onSubmit } = props;
  const { roadmapId } = dataToPass;

  const [state, setState] = useState({
    generating: true,
    failed: false,
    pdfUrl: null,
  });

  const generatePdf = useCallback(async () => {
    setState((prev) => ({ ...prev, generating: true, failed: false }));

    try {
      const token = await StorageProvider.get("authToken");
      const response = await api.get(
        `bx_block_pricingcalculator/road_customizations/${roadmapId}/export_pdf`,
        { headers: { token: token } }
      );

      if (!response.data?.url) {
        throw new Error("missing url");
      }

      setState((prev) => ({ ...prev, generating: false, pdfUrl: response.data.url }));
    } catch (error) {
      setState((prev) => ({ ...prev, generating: false, failed: true, pdfUrl: null }));
    }
  }, [roadmapId]);

  useEffect(() => {
    generatePdf();
  }, [generatePdf]);

  const closeDialog = (data) => {
    onSubmit(data);
  };

  const downloadPdf = async () => {
    try {
      const response = await fetch(state.pdfUrl);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = `${getFormattedPDFName()}.pdf`;
      link.click();

      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      setState((prev) => ({ ...prev, failed: true, pdfUrl: null }));
    }
  };

  const renderGenerating = () => (
    <>
      <Typography align="center" className={classes.title}>
        We&rsquo;re generating your PDF
      </Typography>
      <Typography align="center" className={classes.subtitle}>
        This can take a few seconds
      </Typography>
      <DotSpinner className={classes.spinner} />
    </>
  );

  const renderReady = () => (
    <>
      <Typography align="center" className={classes.title}>
        Your PDF is ready
      </Typography>
      <Typography align="center" className={classes.subtitle}>
        Download your Roadmap to your Local Drive
      </Typography>
      <Button
        id="downloadPDF"
        variant="contained"
        className={classes.actionButton}
        endIcon={<GetAppIcon />}
        onClick={downloadPdf}
      >
        Download PDF
      </Button>
    </>
  );

  const renderFailed = () => (
    <>
      <Typography align="center" className={classes.title}>
        Something went wrong
      </Typography>
      <Typography align="center" className={classes.subtitle}>
        We could not generate your PDF. Please try again.
      </Typography>
      <Button
        id="retryPDF"
        variant="contained"
        className={classes.actionButton}
        endIcon={<RefreshIcon />}
        onClick={generatePdf}
      >
        Try again
      </Button>
    </>
  );

  const renderContent = () => {
    if (state.generating) {
      return renderGenerating();
    }

    return state.failed ? renderFailed() : renderReady();
  };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.rootContainer}
    >
      {renderContent()}
    </Grid>
  );
};

const RoadmapExportDialogWithRouter = withRouter(RoadmapExportDialog);
const RoadmapExportDialogWithToast = withToast(RoadmapExportDialogWithRouter);
const RoadmapExportDialogWithLoader = withLoader(RoadmapExportDialogWithToast);
const RoadmapExportDialogWithAlertBox = withAlertBox(RoadmapExportDialogWithLoader);

export default withStyles((theme) =>
  createStyles({
    rootContainer: {
      padding: theme.spacing(4, 5),
      gap: theme.spacing(1.5),
      minHeight: 240,
    },
    title: {
      color: "#232323",
      fontSize: "2rem",
      fontWeight: 500,
    },
    subtitle: {
      color: "#4F4F4F",
      fontSize: "1.125rem",
    },
    spinner: {
      marginTop: theme.spacing(2),
    },
    actionButton: {
      marginTop: theme.spacing(3),
      backgroundColor: "#39797A",
      color: "#FFFFFF",
      textTransform: "none",
      fontSize: "1rem",
      borderRadius: 8,
      padding: theme.spacing(1.25, 4),
      "&:hover": {
        backgroundColor: "#2F6465",
      },
    },
  })
)(RoadmapExportDialogWithAlertBox);
